import React from 'react';
import ROUTES from '@src/constants/route';
import { useLocation, useHistory } from 'react-router-dom';
import { Typography, DialogTitle, IconButton, Button } from '@mui/material';
import { CloseRounded } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { StyledJoinGroupZalo } from './index.style';

const TopUpBanner = ({ imageUrl, handleClosePopup, open }) => {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const isSupportedRoute = [
    ROUTES.MOBILE_TTS,
    ROUTES.TTS,
    ROUTES.DUBBING,
    ROUTES.HOME,
  ].includes(location.pathname);
  return (
    <StyledJoinGroupZalo
      isSupportedRoute={isSupportedRoute}
      open={open}
      fullWidth
    >
      <div className="dialog-content">
        <DialogTitle classes={{ root: 'dialog-title' }}>
          <IconButton
            aria-label="close"
            onClick={handleClosePopup}
            color="secondary"
            className="close-button"
          >
            <CloseRounded className="close-icon" sx={{ fontSize: 16 }} />
          </IconButton>
        </DialogTitle>

        <div className="dialog-wrapper">
          <div className="img-wrapper">
            <img src={imageUrl} alt="icon" className="img" />
          </div>
          <Typography className="title">
            {t('characterPurchaseSuccessful')}
          </Typography>

          <div className="description">
            {t('descriptioncharacterPurchaseSuccessful')}
          </div>
          <div className="button-container">
            <Button
              variant={isSupportedRoute ? 'contained' : 'outlined'}
              className={
                isSupportedRoute
                  ? 'action-button-contained'
                  : 'action-button-contained btn-outlined'
              }
              onClick={handleClosePopup}
            >
              {isSupportedRoute ? t('gotIt') : t('notNow')}
            </Button>
            {!isSupportedRoute && (
              <Button
                variant="contained"
                className="action-button-contained use-now-button"
                onClick={() => {
                  handleClosePopup();
                  history.push(ROUTES.TTS);
                }}
              >
                {t('useNow')}
              </Button>
            )}
          </div>
        </div>
      </div>
    </StyledJoinGroupZalo>
  );
};

export default TopUpBanner;
